import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MCQSessionCard from "./MCQSessionCard";
import AuthContext from '../../../../auth/AuthContext';
import QuizService from '../../../../services/QuizService';
import AlertService from "../../../../services/AlertService";
import { Skeleton } from "primereact/skeleton";

const QuizMCQSessions = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [loading, setLoading] = useState(false);
    const [sessions, setSessions] = useState([]);
    const authContext = useContext(AuthContext);

    const quizAccess = authContext.getPermissions("quizmaster");

    if (quizAccess.filter((f) => f.access.includes(1)).length === 0) {
        navigate("/");
    }

const loadSessions = useCallback(async (signal) => { 
    setLoading(true);
    try {
      const data = await QuizService.GetSessions(
        state?.id,
        '',
        authContext,
        signal 
      );

      if (signal?.aborted) return; 

      if (data.isSuccess) {
        let i = 0;
        data.data.results.forEach((element) => {
          i++;
          element.no = i;
        });
        setSessions(data.data.results);
      } else {
        AlertService.error(data.errorMessage);
      }
    } catch (err) {
      if (err.name === "AbortError") return; 
    } finally {
      if (!signal?.aborted) setLoading(false); 
    }
  }, [authContext, state?.id]);

useEffect(() => {
    const controller = new AbortController(); 
    loadSessions(controller.signal); 
    return () => controller.abort(); 
  }, [loadSessions, authContext]);

    return (
        <Fragment>
            <div className="container-fluid mt-3 pt-3">
                <div className="row">
                    {loading ? (
                        Array.from({ length: 8 }).map((_, idx) => (
                            <div key={idx} className="col-lg-3 col-md-4 col-sm-6 col-12 p-3">
                                <div className="card border-0 shadow-sm h-100  rounded-0">
                                    <div className="title fw-bold pt-4" style={{ color: '#0D3744' }}>
                                        <center>
                                            <Skeleton width="50%" height="1.5rem" />
                                        </center>
                                    </div>
                                    <div className="score-container pt-4 mb-3">
                                        <center>
                                            <Skeleton width="70%" height="1.5rem" />
                                        </center>
                                    </div>
                                    <div className="p-2">
                                        <center>
                                            <Skeleton width="40%" height="1.5rem" />
                                        </center>
                                    </div>
                                </div>
                            </div>
                        ))) :
                        (
                            sessions &&
                            sessions.map((session, i) => (
                                <div key={i} className="col-lg-3 col-md-4 col-sm-6 col-12 p-3">
                                    <MCQSessionCard id={state?.id} data={session} refreshHandler={loadSessions}></MCQSessionCard>
                                </div>
                            )))}
                    {!loading && sessions && sessions.length === 0 && (
                        <div className="col-12 p-3 text-center">No data available...</div>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default QuizMCQSessions;
